<div *transloco="let t" class="dropdown w-full px-2">
  <div class="relative w-full">
    <label class="sr-only" for="search-input">{{ t("search.dropdown.ariaLabel") }}</label>

    <input
      (blur)="isInputFocused = false"
      (focus)="isInputFocused = true"
      (input)="searchTerm.set($any($event.target).value)"
      (keydown)="onKeyDown($event)"
      [attr.aria-label]="t('search.dropdown.ariaLabel')"
      [placeholder]="isInputFocused ? '' : t('search.dropdown.placeholder')"
      [value]="searchTerm()"
      autocomplete="off"
      class="input input-bordered input-primary rounded-none w-full pr-10"
      id="search-input"
      type="text"
      role="combobox"
      [attr.aria-expanded]="searchTerm() !== ''"
      aria-controls="search-results"
      [attr.aria-activedescendant]="focusedIndex() >= 0 ? 'search-option-' + focusedIndex() : null"
    />

    <div class="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center z-10">
      <button
        (click)="onClear()"
        [attr.aria-label]="t('search.dropdown.clear')"
        [style.display]="searchTerm() !== '' ? 'flex' : 'none'"
        class="btn join-item btn-ghost btn-sm btn-square"
        type="button"
      >
        <i-lucide [img]="closeIcon" aria-hidden="true"></i-lucide>
      </button>
    </div>

    @if (searchTerm() !== "") {
      <div
        [attr.aria-label]="t('search.dropdown.resultsFor', { term: searchTerm() })"
        class="grid grid-cols-1 gap-1 max-h-60 overflow-y-auto absolute left-0 mt-2 shadow dropdown-content bg-base-100 rounded-none w-full z-50 p-2"
        id="search-results"
        role="listbox"
      >
        @if (filteredItems().length > 0) {
          @for (item of filteredItems(); let i = $index; track $index) {
            <div
              #optionItem
              (click)="onSelect(item)"
              (keydown.enter)="onSelect(item)"
              (keydown.space)="onSelect(item); $event.preventDefault()"
              [attr.aria-selected]="focusedIndex() === i"
              [attr.id]="'search-option-' + i"
              [class.bg-base-300]="focusedIndex() === i"
              class="hover:bg-base-200 p-2 rounded-none cursor-pointer"
              role="option"
              tabindex="0"
            >
              {{ item }}
            </div>
          }
        } @else {
          <div class="pointer-events-none p-2" role="status">
            <span class="text-gray-500 italic">
              {{ t("search.dropdown.noResults") }}
            </span>
          </div>
        }
      </div>
    }
  </div>
</div>
